"use client";

import { Typography } from "./Typography";

export interface InlineRowProps {
  label: string;
  children: React.ReactNode;
}

/** Compact label+input row matching LabelValue edit-mode layout (h-8, 40% input width). */
export function InlineRow({ label, children }: InlineRowProps) {
  return (
    <div className="flex items-center gap-2 px-2 rounded-sm h-8">
      <Typography
        as="span"
        variant="body"
        color="light"
        className="whitespace-nowrap shrink-0"
      >
        {label}
      </Typography>
      <span className="shrink-0 min-w-6 flex-1" />
      <span className="min-w-0 w-[40%] shrink-0">{children}</span>
    </div>
  );
}
